import React, { useState, useEffect } from 'react'
import { Card, Modal } from 'antd'
import { useSelector } from 'react-redux'
import { getDashboardIndicator } from '../../services/dashboard/dashboard'
import AntdTable from '../../components/table/AntdTable'
import APIModalTable from './components/APIModalTable'
import { formatMessage, dateTrans, numFormat } from '../../utils/common'

let intervalRef = null

const APIDashboard = () => {
  const commonStore = useSelector(state => state.commonStore)

  const [tagTableList, setTagTableList] = useState([])
  const [tableLoading, setTableLoading] = useState(true)
  const [pageTime, setPageTime] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [selectProductCode, setSelectProductCode] = useState('')
  const [plantCodeList, setPlantCodeList] = useState([])
  const [failCount, setFailCount] = useState(0)

  useEffect(() => {
    intervalRef = setInterval(() => {
      searchDataFun()
    }, 300000)
    searchDataFun()
    return () => {
      // 关闭定时器
      clearInterval(intervalRef)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const searchDataFun = () => {
    setPageTime(new Date().toLocaleString())
    getDashboardIndicator({}).then(res => {
      if (res.errorCode === '200') {
        setTableLoading(false)
        const dataSource = []
        const keys = Object.keys(res.resultData)
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          const value = res.resultData[key]
          dataSource.push(value)
        }
        setTagTableList(dataSource)
      }
    })
  }

  const tagTableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.apiType'),
      dataIndex: 'apiType'
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.failCount'),
      dataIndex: 'failCount',
      render: (text, record) => {
        return (
          <div
            className="link_name"
            onClick={() => {
              tableItemClick(record)
            }}
          >
            {numFormat(text)}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.plant'),
      dataIndex: 'plantCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.lastUpdateTime'),
      dataIndex: 'lastUpdateTime',
      render: text => {
        return text ? dateTrans(text, true) : ''
      }
    }
  ]

  const tableItemClick = record => {
    setFailCount(record.failCount)
    setSelectProductCode(record.apiType)
    let resCode = []
    if (record.plantCode) {
      resCode = record.plantCode?.split(',')
    }
    setPlantCodeList(resCode)
    setModalVisible(true)
  }

  const handleModalCancel = () => {
    setModalVisible(false)
  }

  const handleModalOk = () => {
    setModalVisible(false)
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100%' }}>
      <div style={{ width: '70%' }}>
        <Card bordered={false} bodyStyle={{ padding: 4 }}>
          <div className="content-container">
            <div className="mb15" style={{ fontWeight: 600 }}>
              {formatMessage(commonStore, 'languageObj.dashboard.refreshTime')}
              {pageTime}
            </div>
            <AntdTable bordered dataSource={tagTableList} columns={tagTableColumns} loading={tableLoading} />
          </div>
        </Card>
        <Modal
          open={modalVisible}
          maskClosable={false}
          className="nike_modal"
          width="70%"
          title={formatMessage(commonStore, 'languageObj.dashboard.APIDashboardLog')}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          destroyOnClose
          footer={null}
        >
          <APIModalTable apiType={selectProductCode} plantCodeList={plantCodeList} failCount={failCount} />
        </Modal>
      </div>
    </div>
  )
}
export default APIDashboard
